module.exports = __webpack_public_path__ + "accdbc43559c40ab5e28c497792f847a.svg";